import { Button, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { NavBarButtonGroup, UnselectButton } from "~/features/navbar/Navbar";
import { useFcNavigate } from "~/hooks/useFcNavigate";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { selectBatch } from "./carts.slice";

export function CartsToolbar() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useFcNavigate();
  const trackedPageName = useMixpanelPageName();

  const selectedBatch = useAppSelector((state) => state.carts.selectedBatch);

  const stageButtonText =
    (selectedBatch && selectedBatch.batchType) !== "Bulk"
      ? t("stage totes")
      : t("stage bulk");

  return (
    <Toolbar>
      <UnselectButton
        onClick={() => {
          mixpanelTrack({
            trackedPageName,
            type: "Button Click",
            label: "Unselect Batch",
            eventProperties: {
              "Batch Name": selectedBatch?.batchName
            }
          });
          dispatch(selectBatch(null));
        }}
      />
      <NavBarButtonGroup>
        {selectedBatch && (
          <Button
            color="secondary"
            onClick={(): void => {
              mixpanelTrack({
                trackedPageName,
                type: "Button Click",
                label:
                  selectedBatch.batchType !== "Bulk"
                    ? "Stage Totes"
                    : "Stage Bulk",
                eventProperties: {
                  "Batch Name": selectedBatch.batchName,
                  "Batch Type": selectedBatch.batchType
                }
              });
              navigate(`/batches/${selectedBatch.batchName}/stage`);
            }}
          >
            <Typography variant="body2" style={{ color: "#fff" }}>
              {stageButtonText}
            </Typography>
          </Button>
        )}
      </NavBarButtonGroup>
    </Toolbar>
  );
}
